module.exports = __webpack_public_path__ + "static/img/ni.66627f1f.svg";